import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { BaseSubMaintenanceController } from '../../../_base/BaseSubMaintenanceController';
import { AccessControlTransitionActionListMaintenanceDto } from './AccessControlTransitionActionListMaintenanceDto';
import { AccessControlTransitionActionItemMaintenanceDto } from './AccessControlTransitionActionItemMaintenanceDto';

@Injectable()
export class AccessControlTransitionActionSubMaintenanceController
    extends BaseSubMaintenanceController<AccessControlTransitionActionListMaintenanceDto, AccessControlTransitionActionItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, 'accesscontrol/transition/action');
    }

    public getResourceRoot(): string {
        return 'ACCESSCONTROL.TRANSITION.ACTION';
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return '/system/screensandforms/accesscontrolsetting/' + parentId + '/' + optionParentid + '/submain' + uri;
    }
}
